/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeclineRiskPolicyChallengeResponseBody = {
  /**
   * Whether the challenge is now declined.
   */
  declined: boolean;
};

/** @internal */
export const DeclineRiskPolicyChallengeResponseBody$inboundSchema:
  z.ZodMiniType<DeclineRiskPolicyChallengeResponseBody, unknown> = z.object({
    declined: z.boolean(),
  });

export function declineRiskPolicyChallengeResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<DeclineRiskPolicyChallengeResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      DeclineRiskPolicyChallengeResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeclineRiskPolicyChallengeResponseBody' from JSON`,
  );
}
